<head>
    <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
        />
</head>

<div class="dashboard-panel-container">
    <div class="custom-container">
        <!-- <mat-icon color="primary" class="back-arrow" [routerLink]="'/dashboard'">arrow_back</mat-icon> -->
        <div class="row">
            <div class="col-md-3" *ngIf="'ControlUsuarios' | permissionFilter">
                <mat-card class="mat-card">
                    <mat-icon aria-hidden="false" aria-label="Example home icon">group</mat-icon>
                    <mat-card-title>Usuarios</mat-card-title>
                    <p>Control de Usuarios</p>
                    <button mat-raised-button color="primary" [routerLink]="'/users'">Entrar</button>
                </mat-card>
            </div>

            <div class="col-md-3" *ngIf="'ControlRoles' | permissionFilter">
                <mat-card class="mat-card">
                    <mat-icon aria-hidden="false" aria-label="Example home icon">key</mat-icon>
                    <mat-card-title>Permisos</mat-card-title>
                    <p>Control de Permisos</p>
                    <button mat-raised-button color="primary" [routerLink]="'/roles'">Entrar</button>
                </mat-card>
            </div>

            
            <div class="col-md-3">
                <mat-card class="mat-card">
                    <mat-icon aria-hidden="false" aria-label="Example home icon">login</mat-icon>
                    <mat-card-title>Bitácora de Sesiones</mat-card-title>
                    <p>Bitácora de Sesiones</p>
                    <button mat-raised-button color="primary" [routerLink]="'/userLogs'">Entrar</button>
                </mat-card>
            </div>
            
            <!-- <div class="col-md-3">
                <mat-card>
        <mat-icon aria-hidden="false" aria-label="Example home icon">settings_suggest</mat-icon>
                    <mat-card-title>Clientes</mat-card-title>
                    <p>Configuración de Clientes del Sistema</p>
                    <button mat-raised-button color="primary" [routerLink]="'/dashboardAdmin'" routerLinkActive="router-link-active" >Entrar</button>
                </mat-card>
            </div> -->
        </div>
        <div class="row" style="margin-top: 20px;">
            <div class="col-md-3" *ngIf="'ControlAlarmasSistema' | permissionFilter">
            <!-- <div class="col-md-3" *ngIf="true">     -->
                <mat-card class="mat-card">
                    <mat-icon aria-hidden="false" aria-label="Example home icon">alarm</mat-icon>
                    <mat-card-title>Alarmas de sistema</mat-card-title>
                    <p>Control de Alarmas de Sistema</p>
                    <button mat-raised-button color="primary" [routerLink]="'/systemAlarms'">Entrar</button>
                </mat-card>
            </div>
        </div>
    </div>
</div>